<template>
  <div ref="scroll_div" class="scroll_div" style="width:100%;height:100%;position:relative;">
      <img src="@/assets/img/toko2.jpg" style="width:6.40rem;" usemap="#Map" >
    <!--
      <map name="Map">
        <area shape="rect" coords="1,2,52,29" id="top" name="top" href="#top" alt="">
        <area shape="rect" coords="20,780,94,830" id="shishi" href="#shishi">
        <area shape="rect" coords="9,2296,91,2351" id="shili"  name="shili" href="#shili">
        <area shape="rect" coords="5,3614,32,3651" id="wenhe" href="#wenhe">
      </map>
    -->
    <div id="top" style="position: absolute;top:0rem;left:0rem;width:0.30rem;height:0.30rem;"></div>
    <div id="shishi" style="position: absolute;top:7.80rem;left:0rem;width:0.30rem;height:0.30rem;"></div>
    <div id="shili" style="position: absolute;top:22.96rem;left:0rem;width:0.30rem;height:0.30rem;"></div>
    <div id="wenhe" style="position: absolute;top:36.14rem;left:0rem;width:0.30rem;height:0.30rem;"></div>


    <div  ref="float_menu" style="position: fixed;left:5.52rem;top:0.40rem;z-index: 100;width:0.52rem;height:0.24rem;">
      <div style="position:relative;">
    <el-dropdown trigger="click" style="top:-0.7rem;">
<!--
      <el-affix :offset="120">
        <el-button type="primary">Offset top 120px</el-button>

      </el-affix>
-->
      <img src="@/assets/img/menu.png" style="width:0.52rem;height:0.24rem;">

      <template #dropdown >
        <el-dropdown-menu>
          <el-dropdown-item @click="go('top')" >Kyoto Toko</el-dropdown-item>
          <el-dropdown-item @click="go('shishi')">私たちの仕事</el-dropdown-item>
          <el-dropdown-item @click="go('shili')">案件事例</el-dropdown-item>
          <el-dropdown-item @click="go('wenhe')">問い合わせ</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
        </div>
      </div>

  </div>
</template>

<script>
import {ref,onMounted} from "vue";
export default {
  name: "Home",
  setup() {

    const scroll_div = ref(null);
    const float_menu = ref(null);

    const go = (anchor) => {


      document.querySelector("#"+anchor).scrollIntoView({
        behavior: "smooth",  // 平滑过渡
        block:    "start"  // 上边框与视窗顶部平齐。默认值
      });

      //const returnEle = document.querySelector(anchor);
      //if (returnEle) {
        //returnEle.scrollIntoView(true);
      //}
    }

    //得到scroll_div左侧位置
    onMounted(()=>{
      console.log(scroll_div.value.getBoundingClientRect())
      // watchEffect(()=>{
      //   console.log(stateDom.value)
      // })
     let rect = scroll_div.value.getBoundingClientRect();
      let left = rect.left;
      console.log('left:'+left);

      let dest_l = left+(rect.width * 552 / 640);

      float_menu.value.style.left = dest_l +'px';

    })

    return {
      go,
      scroll_div,
      float_menu,
    }

  },
}
</script>

<style scoped>
/*
.scroll_div::-webkit-scrollbar {
  display: none;
}

.scroll_div {
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow-x: hidden;
  overflow-y: auto;
}
*/
</style>